(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('SelectedRulesEmailController', SelectedRulesEmailController);

    SelectedRulesEmailController.$inject = ['$state', '$uibModalInstance', 'Authority'];

    function SelectedRulesEmailController($state, $uibModalInstance, Authority) {
        var vm = this;

        vm.selectedAut = {};
        vm.authorities = [];
        Authority.query().$promise.then(function (authorities) {
            vm.selectedAut = {id: -1, name: authorities[authorities.length -1]};
            authorities.sort();

            var i = 0;
            authorities.forEach(a => {
                vm.authorities.push({id: i, name: a});
                i++;
            });
        });

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            $uibModalInstance.close(vm.selectedAut.name);
        };
    }
})();
